import React, { useState, useEffect, useMemo } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { Eye } from "lucide-react";
import { TbEdit,TbEye } from "react-icons/tb";
import AddUser from "./Assets/AddUser";
import EditUser from "./Assets/EditUser";
import DeleteUser from "./Assets/DeleteModal";
import ViewUser from "./Assets/UserModel";
import { toast } from "react-toastify";

const UserDetails = () => {
  const [users, setUsers] = useState([]);
  const [roleDetails, setRoles] = useState([]);
  const [departmentDetails, setDepartmentDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [addUserModel, setAddUserModel] = useState(false);
  const [editUserModel, setEditUserModel] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [viewUserModel, setViewUserModel] = useState(false);
  const [itemToView, setItemToView] = useState(null);

  const itemsPerPage = 20;

  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchUsers();
  }, []);
  // fetch the all data
  const fetchUsers = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");
      
      const result = await response.json();
      setUsers(result.users || []);
      setRoles(result.roles || []);
      let departmentsData = [];
      if (Array.isArray(result.departments)) {
        departmentsData = result.departments;
      } else if (result.departments?.data && Array.isArray(result.departments.data)) {
        departmentsData = result.departments.data;
      }
      setDepartmentDetails(departmentsData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredUsers = useMemo(() => {
    const today = new Date();
    let filtered = users.filter((u) => {
      const nameMatch = u.name?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        const createdDate = new Date(u.created_at);
        if (!isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);
        } else {
          matchesDate = false;
        }
      }
      let matchDepartment = true;
      if (departmentFilter) {
        matchDepartment = u.department_id === Number(departmentFilter);
        
      }

      return nameMatch && matchesDate && matchDepartment;
    });

    
    if (sortOption === "name-asc") {
      filtered.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    } else if (sortOption === "date-asc") {
      filtered.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    } else if (sortOption === "date-desc") {
      filtered.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    }

    return filtered;
  }, [users, search, daysFilter,departmentFilter, sortOption]);

  // Pagination Method
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  const handleAddUserClick = () => {
    setAddUserModel(true);
  };

  const cancelAddUser = () => {
    setAddUserModel(false);
  };
  
    const confirmAddUser = async (formData) => {
    try {
      
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/users/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
        body: JSON.stringify(formData),  
      });

      const errorText = await response.json();
      
      if (!response.ok) {
        
        toast.error(errorText.message || "User Added Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
        
      }else{
        toast.success(errorText.message || "User Added Successfully");
      }
    } catch (error) {
      console.error("Error saving user:", error);
    }
    fetchUsers();
    setAddUserModel(false);
  };

  const handleEditUserClick = (user) => {
    setItemToEdit(user);
    setEditUserModel(true);
  };

  const cancelEditUser = () => {
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const confirmEditUser = async (formData) => {
    try {

      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/users/edit/${formData.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData), 
      });

      const errorText = await response.json();
      
      if (!response.ok) {
        
        toast.error(errorText.message || "User Updated Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User Updated Successfully");
      }
    } catch (error) {
      console.error("Error saving user:", error);
    }
    fetchUsers();
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {


      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/users/delete/${itemToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      const errorText = await response.json();
      if (!response.ok) {

        toast.error(`${errorText.message} (Tasks: ${errorText.task_count}, Logs: ${errorText.log_count})` || "Failed to delete user");
        throw new Error(`Failed to delete user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
    fetchUsers();
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

    const handleViewClick = (id) => {
      setItemToView(id);
      setViewUserModel(true);
    };



        const cancelView = () => {
      setViewUserModel(false);
      setItemToView(null);
    };

    const getRoleName = (id) => {
    const role = roleDetails.find((r) => r.id === id);
    return role ? role.name : `Role ID: ${id}`;
  };
      const getDepartmentName = (id) => {
    const department = departmentDetails.find((r) => r.id === id);
    return department ? department.name : `Role ID: ${id}`;
  };

  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">User List</h2>
      <div className="flex justify-between items-center mb-4">
      <div className="user-heading">
        <button className="text-sm font-normal bg-blue-500 p-2 rounded text-white cursor-pointer" onClick={() => handleAddUserClick()}>Add New User</button>
      </div>
      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by user name..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />
        <select
          value={departmentFilter}
          onChange={(e) => {
            setDepartmentFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Select Department</option>
            {departmentDetails.map((d, index) => (
              <option value={d.id}>{d.name}</option>))
            }
          
        </select>
        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Department</th>
            <th className="px-4 py-2 text-left">Designation</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((u, index) => (
              <tr key={u.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2"><img src={u.avatar} alt={u.name} className="w-10 h-10 rounded-full object-cover" /><span>{u.name || "N/A"}</span></div></td>
                <td className="px-4 py-2">{u.email || "N/A"}</td>
                <td className="px-4 py-2">{getDepartmentName(u.department_id) || "N/A"}</td>
                <td className="px-4 py-2">{getRoleName(u.role) || "N/A"}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleViewClick(u.id)}>
                    <TbEye size={22}  />
                  </button>
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEditUserClick(u)}>
                    <TbEdit size={22} />
                  </button>
                  <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(u.id)}>
                    <MdDeleteOutline size={22} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      {addUserModel && (
        <AddUser
          
          onClose={cancelAddUser}
          onSubmit={(formData) => confirmAddUser(formData)}
        />
      )}
      {editUserModel && (
        <EditUser
          user={itemToEdit}
          onClose={cancelEditUser}
          onEdit={(formData) => confirmEditUser(formData)}
        />
      )}
      {deleteModalShow && (
        <DeleteUser
          itemName={
            currentUsers.find((p) => p.id === itemToDelete)?.name || "Unknown User"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
      {viewUserModel && (
        <ViewUser
          user={currentUsers.find((p) => p.id === itemToView) || null}
          onClose={cancelView}
        />
      )}
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
